import dayjs from 'dayjs';

const FORMAT = 'YYYY-MM-DD';

// 목록 검색의 기본 조회범위(오늘 기준 앞뒤 1년)를 계산한다.
//
// 비워두면(검색 시작일/종료일이 빈 문자열) 전체 기간이 조회돼 목록이 과도하게 길어지고,
// 입력란도 "YYYY-MM-DD" placeholder에 빨간 에러 테두리로 보인다.
// 금년(1/1~12/31)으로 고정하면 연초/연말에 반대쪽 데이터가 빠지고,
// 끝을 오늘로 막으면 앞으로 잡힌 건(매출 예정일 등 미래 날짜)이 안 보인다.
// 그래서 영업 진행 현황(/chancemng), 프로젝트 관리(/projectmng), 유지보수 관리 등에서 쓰는
// recentOneYearStr/recentOneYearEndStr(src/utils/calcDatetime.js)와 같은 폭(앞뒤 1년)을 쓰되,
// 호출 시점(dayjs()) 기준으로 계산한다.
export const getDefaultSearchRange = () => {
  const today = dayjs();

  return {
    searchStrtDt: today.subtract(1, 'year').format(FORMAT),
    searchEndDt: today.add(1, 'year').format(FORMAT),
  };
};

export default getDefaultSearchRange;
